export const PLANT_MEAN_SIZE_ANALYSIS_COLOURS = [
  '#ffa600',
  '#a05195',
  '#289f2c',
  '#22ffff',
];
